import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSage from "../Saga/Saga";
import TestReducer from "../Slices/TestSlicers/TestSlicers";
import SessionExpiredReducer from "../Slices/SessionExpired/SessionExpired";
import EditUserPermissionsReducer from "../Slices/UserPermission/UpdateUserPermissionSlicer";
import UserPermissionRowsReducer from "../Slices/UserPermission/UserPermissionRowsSlicer";
import LoginReducer from "../Slices/LoginSlicer/LoginSlicer";
import GoogleLoginReducer from "../Slices/LoginSlicer/GoogleLoginSlicer";
import RegistrationSlicerReducer from "../Slices/Registration/RegistrationSlicer";
import ListRegistrationYeargroupSliceReducer from "../Slices/Registration/ListRegistrationYeargroupSlice";

import ResetPasswordReducer from "../Slices/ResetPassword/ResetPassword";
import SideMenuPermissionReducer from "../Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import PermissionsToPageReducer from "../Slices/UserPermission/PermissionsToPage";
import ForgotPasswordReducer from "../Slices/LoginSlicer/ForgotPassword";
import DashboardCardReducer from "../Slices/Dashboard/DashboardCard";
import DashboardChartReducer from "../Slices/DashboardChart/DashboardChart";
import DashboardDataCardReducer from "../Slices/DashboardData/DashboardDataCard";
import ThemeReducer from "../Slices/Theme/ThemeSlice";
// Menu
import ListMenuSliceReducer from "../Slices/Menu/ListMenuSlice";
import AddMenuSlice from "../Slices/Menu/AddMenuSlice";
import EditMenuSliceReducer from "../Slices/Menu/EditMenuSlice";
import DeleteMenuReducer from "../Slices/Menu/DeleteMenuSlice";

// Screen
import ScreenListReducer from "../Slices/Screen/ScreenList";

// Questions
import ListQuestionsSliceReducer from "../Slices/Questions/ListQuestionsSlice";
import QuestionMappingSliceReducer from "../Slices/Questions/QuestionMappingSlice";
import AddQuestionsSlice from "../Slices/Questions/AddQuestionsSlice";
import EditQuestionsSliceReducer from "../Slices/Questions/EditQuestionsSlice";
import DeleteQuestionsReducer from "../Slices/Questions/DeleteQuestionsSlice";
import BulkUploadQuestionsSliceReducer from "../Slices/Questions/BulkUploadQuestionsSlice";

// ExamHistory
import ListMockExamHistorySliceReducer from "../Slices/ExamHistory/ListMockExamHistorySlice";
import ListExamHistorySliceReducer from "../Slices/ExamHistory/ListExamHistorySlice";
import ListExamHistoryReWritingSliceReducer from "../Slices/ExamHistory/ListExamHistoryReWritingSlice";
import AddExamHistorySlice from "../Slices/ExamHistory/AddExamHistorySlice";
import EditExamHistorySliceReducer from "../Slices/ExamHistory/EditExamHistorySlice";
import DeleteExamHistoryReducer from "../Slices/ExamHistory/DeleteExamHistorySlice";

// Options
import ListOptionsSliceReducer from "../Slices/Options/ListOptionsSlice";
import AddOptionsSlice from "../Slices/Options/AddOptionsSlice";
import EditOptionsSliceReducer from "../Slices/Options/EditOptionsSlice";
import DeleteOptionsReducer from "../Slices/Options/DeleteOptionsSlice";

import ListReExamPracticeIDSliceReducer from "../Slices/ReExamPractice/ListReExamPracticeSlice";
// Exam
import ListReViewExamIDSliceReducer from "../Slices/ReViewExam/ListReViewExamSlice";
import ListReExamIDSliceReducer from "../Slices/ReExam/ListReExamSlice";
import PendingExamSliceReducer from "../Slices/PendingExam/PendingExamSlice";
import ListExamsubmitSliceReducer from "../Slices/ExamAnswer/ListExamsubmitSlice";
import ListExamIDSliceReducer from "../Slices/Exam/ListExamIDSlice";
import ListEvaluationSliceReducer from "../Slices/Exam/ListEvaluationSlice";
import ListEvaluationPracticewritingExamSliceReducer from "../Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import ListExamSliceReducer from "../Slices/Exam/ListExamSlice";
import AddExamSlice from "../Slices/Exam/AddExamSlice";
import AddCloseSectionSliceReducer from "../Slices/Exam/AddCloseSectionSlice";
import EditExamSliceReducer from "../Slices/Exam/EditExamSlice";
import DeleteExamReducer from "../Slices/Exam/DeleteExamSlice";
import AddOpenSectionSliceReducer from "../Slices/OpenSection/AddOpenSectionSlice";
import ListExamsubmitoverallSliceReducer from "../Slices/ExamAnswer/ListExamsubmitoverallSlice";
// Practice List
import ListPracticeTestSliceReducer from "../Slices/PracticeTest/ListPracticeTestSlice";
// Practice Exam
import ListEvaluationPracticeSliceReducer from "../Slices/PracticeExam/ListEvaluationPracticeSlice";
import ListExamsubmitPracticeSliceReducer from "../Slices/ExamAnswerPractice/ListExamsubmitPracticeSlice";
import ListPracticeExamIDSliceReducer from "../Slices/PracticeExam/ListPracticeExamIDSlice";
import ListInstructionPracticeExamSliceReducer from "../Slices/PracticeExam/ListinstructionPracticeExamIDSlice";
import ListPracticeExamSliceReducer from "../Slices/PracticeExam/ListPracticeExamSlice";
import PendingPracticeExamSliceReducer from "../Slices/PendingPracticeExam/PendingPracticeExamSlice";
import AddPracticeExamSlice from "../Slices/PracticeExam/AddPracticeExamSlice";
import EditPracticeExamSliceReducer from "../Slices/PracticeExam/EditPracticeExamSlice";
import DeletePracticeExamReducer from "../Slices/PracticeExam/DeletePracticeExamSlice";

// StudentPractice Exam
import PopupStudentExamPracticeSliceReducer from "../Slices/StudentExamPractice/PopupStudentExamPracticeSlice";
import EditStudentExamPracticeSliceReducer from "../Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import ListStudentExamPracticeSliceReducer from "../Slices/StudentExamPractice/ListStudentExamPracticeSlice";
import AddStudentExamPracticeSlice from "../Slices/StudentExamPractice/AddStudentExamPracticeSlice";

// Student Exam
import PopupStudentExamSliceReducer from "../Slices/StudentExam/PopupStudentExamSlice";
import EditStudentExamSliceReducer from "../Slices/StudentExam/EditStudentExamSlice";
import ListStudentExamSliceReducer from "../Slices/StudentExam/ListStudentExamSlice";
import AddStudentExamSlice from "../Slices/StudentExam/AddStudentExamSlice";
// Instruction
import ListInstructionSliceReducer from "../Slices/Instruction/ListInstructionSlice";
import AddInstructionSlice from "../Slices/Instruction/AddInstructionSlice";
import EditInstructionSliceReducer from "../Slices/Instruction/EditInstructionSlice";
import DeleteInstructionReducer from "../Slices/Instruction/DeleteInstructionSlice";

// ExamAnswer Practice
import ListExamAnswerPracticeSliceReducer from "../Slices/ExamAnswerPractice/ListExamAnswerPracticeSlice";
import AddExamAnswerPracticeSlice from "../Slices/ExamAnswerPractice/AddExamAnswerPracticeSlice";

// ExamAnswer
import ListExamAnswerSliceReducer from "../Slices/ExamAnswer/ListExamAnswerSlice";
import AddExamAnswerSlice from "../Slices/ExamAnswer/AddExamAnswerSlice";
import EditExamAnswerSliceReducer from "../Slices/ExamAnswer/EditExamAnswerSlice";
import DeleteExamAnswerReducer from "../Slices/ExamAnswer/DeleteExamAnswerSlice";

// QuestionType
import ListQuestionTypeSliceReducer from "../Slices/QuestionType/ListQuestionTypeSlice";
import AddQuestionTypeSlice from "../Slices/QuestionType/AddQuestionTypeSlice";
import EditQuestionTypeSliceReducer from "../Slices/QuestionType/EditQuestionTypeSlice";
import DeleteQuestionTypeReducer from "../Slices/QuestionType/DeleteQuestionTypeSlice";
import ListDashboardPerformenceTrendReducer from "../Slices/QuestionType/ListDashboardPerformanceTrend";
import ScheduleQuestionTypesSliceReducer from "../Slices/QuestionType/ScheduleQuestionTypesSlice";
// year group
import ListyearGroupSliceReducer from "../Slices/yearGroup/ListyearGroupSlice";
import AddyearGroupSlice from "../Slices/yearGroup/AddyearGroupSlice";
import EdityearGroupSliceReducer from "../Slices/yearGroup/EdityearGroupSlice";
import DeleteyearGroupReducer from "../Slices/yearGroup/DeleteyearGroupSlice";
// QuestionSubType
import ListQuestionSubTypeSliceReducer from "../Slices/QuestionSubType/ListQuestionSubTypeSlice";
import QuestionSubTypelistSliceReducer from "../Slices/QuestionSubType/QuestionSubTypelistSlice";
import AddQuestionSubTypeSlice from "../Slices/QuestionSubType/AddQuestionSubTypeSlice";
import EditQuestionSubTypeSliceReducer from "../Slices/QuestionSubType/EditQuestionSubTypeSlice";
import DeleteQuestionSubTypeReducer from "../Slices/QuestionSubType/DeleteQuestionSubTypeSlice";
// ExamModel
import ListExamModelSliceReducer from "../Slices/ExamModel/ListExamModelSlice";
import AddExamModelSlice from "../Slices/ExamModel/AddExamModelSlice";
import EditExamModelSliceReducer from "../Slices/ExamModel/EditExamModelSlice";
import DeleteExamModelReducer from "../Slices/ExamModel/DeleteExamModelSlice";

// FeedBack
import ListFeedBackSliceReducer from "../Slices/FeedBack/ListFeedBackSlice";
import AddFeedBackSlice from "../Slices/FeedBack/AddFeedBackSlice";
import EditFeedBackSliceReducer from "../Slices/FeedBack/EditFeedBackSlice";
import DeleteFeedBackReducer from "../Slices/FeedBack/DeleteFeedBackSlice";
import AddFeedBackPracticeSliceReducer from "../Slices/FeedBackPractice/AddFeedBackPracticeSlice";
// UserProfile
import ListUserProfileSliceReducer from "../Slices/UserProfile/ListUserProfileSlice";
import AddUserProfileSlice from "../Slices/UserProfile/AddUserProfileSlice";
import EditUserProfileSliceReducer from "../Slices/UserProfile/EditUserProfileSlice";
import DeleteUserProfileReducer from "../Slices/UserProfile/DeleteUserProfileSlice";

// User Admin
import ListUserAdminSliceReducer from "../Slices/UserAdmin/ListUserAdminSlice";
import AddUserAdminSliceReducer from "../Slices/UserAdmin/AddUserAdminSlice";
import EditUserAdminSliceReducer from "../Slices/UserAdmin/EditUserAdminSlice";
import DeleteUserAdminReducer from "../Slices/UserAdmin/DeleteUserAdminSlice";

// User
import ListUserSliceReducer from "../Slices/User/ListUserSlice";
import AddUserSlice from "../Slices/User/AddUserSlice";
import EditUserSliceReducer from "../Slices/User/EditUserSlice";
import DeleteUserReducer from "../Slices/User/DeleteUserSlice";
import ListRegionSliceReducer from "../Slices/User/ListRegionSlice";
import ListYearGroupSliceReducer from "../Slices/User/ListYearGroupSlice";
// Package
import ListPackageSliceReducer from "../Slices/Package/ListPackageSlice";
import AddPackageSlice from "../Slices/Package/AddPackageSlice";
import EditPackageSliceReducer from "../Slices/Package/EditPackageSlice";
import DeletePackageReducer from "../Slices/Package/DeletePackageSlice";
import ListPackageDomainSliceReducer from "../Slices/Package/ListPackageDomainSlice";
import ListDomainSliceReducer from "../Slices/Package/ListDomainSlice";
import ListSubscribedUserSliceReducer from "../Slices/Package/ListSubscribedUserSlice";
import ListPackagePeriodSliceReducer from "../Slices/Package/ListPackagePeriodSlice";

// Courses
import ListCoursesSliceReducer from "../Slices/Courses/ListCoursesSlice";
import AddCoursesSlice from "../Slices/Courses/AddCoursesSlice";
import EditCoursesSliceReducer from "../Slices/Courses/EditCoursesSlice";
import DeleteCoursesReducer from "../Slices/Courses/DeleteCoursesSlice";
// skill
import AddArithmeticGameSkillSlice from "../Slices/ArithmeticGameSkill/AddArithmeticGameSkillSlice";
import AddMemoryGameSkillSlice from "../Slices/MemoryGameSkill/AddMemoryGameSkillSlice";
// userPackage
import PendingExamListReducer from "../Slices/UserPackage/PendingExamListSlice";
import ListUserPackageSliceReducer from "../Slices/UserPackage/ListUserPackageSlice";
import ListUserPackageDetailsSliceReducer from "../Slices/UserPackage/ListUserPackageDetailsSlice";
import ListUserExamListSliceReducer from "../Slices/UserPackage/ListUserExamListSlice";
// Country
import ListCountrySliceReducer from "../Slices/Country/ListCountrySlice";
import AddCountrySlice from "../Slices/Country/AddCountrySlice";
import EditCountrySliceReducer from "../Slices/Country/EditCountrySlice";
import DeleteCountryReducer from "../Slices/Country/DeleteCountrySlice";

// ContentMobile
import ListContentMobileSliceReducer from "../Slices/ContentMobile/ListContentMobileSlice";
import AddContentMobileSlice from "../Slices/ContentMobile/AddContentMobileSlice";
import EditContentMobileSliceReducer from "../Slices/ContentMobile/EditContentMobileSlice";
import DeleteContentMobileReducer from "../Slices/ContentMobile/DeleteContentMobileSlice";

// SubtopicMobile
import ListSubtopicMobileSliceReducer from "../Slices/SubtopicMobile/ListSubtopicMobileSlice";
import AddSubtopicMobileSlice from "../Slices/SubtopicMobile/AddSubtopicMobileSlice";
import EditSubtopicMobileSliceReducer from "../Slices/SubtopicMobile/EditSubtopicMobileSlice";
import DeleteSubtopicMobileReducer from "../Slices/SubtopicMobile/DeleteSubtopicMobileSlice";

// subject mobile
import ListSubjectMobileSliceReducer from "../Slices/SubjectMobile/ListSubjectMobileSlice";
import AddSubjectMobileSlice from "../Slices/SubjectMobile/AddSubjectMobileSlice";
import EditSubjectMobileSliceReducer from "../Slices/SubjectMobile/EditSubjectMobileSlice";
import DeleteSubjectMobileReducer from "../Slices/SubjectMobile/DeleteSubjectMobileSlice";

// mapSubscribed
import ListSubscribedMapSliceReducer from "../Slices/SubscribedMap/ListSubscribedMapSlice";
import AddSubscribedMapSlice from "../Slices/SubscribedMap/AddSubscribedMapSlice";
import EditSubscribedMapSliceReducer from "../Slices/SubscribedMap/EditSubscribedMapSlice";
import DeleteSubscribedMapReducer from "../Slices/SubscribedMap/DeleteSubscribedMapSlice";

//  billing
import ListBillingSliceReducer from "../Slices/Billing/ListBillingSlice";

//  mock exam
import MockExamSliceReducer from "../Slices/MockExam/ListMockExamSlice";
import ListInstructionExamSliceReducer from "../Slices/Exam/ListinstructionExamIDSlice";
//  Reading prompt
import ReadingPromptSliceReducer from "../Slices/ReadingPrompt/ListReadingPromptSlice";

// Writing Exam main
import ListWritingExamAISliceReducer from "../Slices/Writing_Exam/ListWriting_Exam_AI_Slice";
// Writing Exam
import ListWritingExamAIPracticeSliceReducer from "../Slices/Writing_Exam_Practice/ListWriting_Exam_AI_PracticeSlice";
import ListWritingExamPracticeSliceReducer from "../Slices/Writing_Exam_Practice/ListWriting_Exam_PracticeSlice";
//  chatbot
import ChatbotSlicerReducer from "../Slices/Chatbot/ChatbotSlicer";

import ChatbotPublicSlicerReducer from "../Slices/ChatbotPublic/ChatbotPublicSlicer";
import WritingChatbotPublicReducer from "../Slices/ChatbotPublic/WritingChatbotPublicSlicer";
import ExamWritingChatbotPublicReducer from "../Slices/ChatbotPublic/ExamWritingChatbotPublicSlicer";
import ReadChatbotPublicReducer from "../Slices/ChatbotPublic/ReadChatbotPublicSlicer";
import ExamReadChatbotPublicReducer from "../Slices/ChatbotPublic/ExamReadChatbotPublicSlicer";
import ChatpracticeEvaluationSlicerReducer from "../Slices/ChatbotpracticeEvaluation/ChatpracticeEvaluationSlicer";

import ChatbotExamEvaluationSlicerReducer from "../Slices/ChatbotExamEvaluation/ChatbotExamEvaluationSlicer";

import ListReViewExamIDPracticeSliceReducer from "../Slices/ReViewExamPractice/ListReViewExamPracticeSlice";
// setting
import ListSettingResetSliceReducer from "../Slices/Setting/ListSettingResetSlice";
import ListSettingResetMockSliceReducer from "../Slices/Setting/ListListSettingResetMockSlice";
import AddSettingSliceReducer from "../Slices/Setting/AddSettingSlice";
import ListSubscriptionSliceReducer from "../Slices/Subscription/ListSubscriptionSlice";
import AddSubscriptionSliceReducer from "../Slices/Subscription/AddSubscriptionSlice";
import DeleteSubscriptionReducer from "../Slices/Subscription/DeleteSubscriptionSlice";

// New Dashbord
import ListDailygoalsSliceReducer from "../Slices/NewDashboardAPI/ListdailygoalsSlice";
import ListDashboardprogressSliceReducer from "../Slices/NewDashboardAPI/ListDashboardprogressSlice";
import ListPerformanceSliceReducer from "../Slices/NewDashboardAPI/ListPerformanceSlice";
import ListPrefmanceTrendSliceReducer from "../Slices/NewDashboardAPI/ListPrefmanceTrendSlice";
import ListQuestionBankSliceReducer from "../Slices/NewDashboardAPI/ListQuestionBankSlice";
import ListRecentActivitySliceReducer from "../Slices/NewDashboardAPI/ListRecentActivitySlice";
import AddCreategoalsSliceSlice from "../Slices/NewDashboardAPI/AddCreategoalsSlice";

// Yearlevel_map
import ListYearlevel_mapSliceReducer from "../Slices/Yearlevel_map/ListYearlevel_mapSlice";
import AddYearlevel_mapSlice from "../Slices/Yearlevel_map/AddYearlevel_mapSlice";
import EditYearlevel_mapSliceReducer from "../Slices/Yearlevel_map/EditYearlevel_mapSlice";
import DeleteYearlevel_mapReducer from "../Slices/Yearlevel_map/DeleteYearlevel_mapSlice";

//  Study
import ListSubjectNoteSliceReducer from "../Slices/StudyNote/SubjectStudyNode";
import ListSubjectNoteTopicSliceReducer from "../Slices/StudyNote/TopicStudyNode";
import ListSubjectNoteContentSliceReducer from "../Slices/StudyNote/TopicStudyNodeContent";
import ListSubjectNoteSubTopicSliceReducer from "../Slices/StudyNote/TopicSubStudyNode";

// Examdate
import ListExamdateSliceReducer from "../Slices/Examdate/ListExamdateSlice";
import AddExamdateSlice from "../Slices/Examdate/AddExamdateSlice";
import EditExamdateSliceReducer from "../Slices/Examdate/EditExamdateSlice";
import DeleteExamdateReducer from "../Slices/Examdate/DeleteExamdateSlice";
// exter api
import ListCountryListSliceReducer from "../Slices/ExterAPI/ListCountryListSlice";
import ListStateSliceReducer from "../Slices/ExterAPI/ListStateSlice";

import AddSupportSliceReducer from "../Slices/Support/AddSupportSlice";
import ListFAQSliceReducer from "../Slices/Support/ListFAQSlice";
// Role
import ListRoleSliceReducer from "../Slices/Role/ListRoleSlice";
import AddRoleSlice from "../Slices/Role/AddRoleSlice";
import EditRoleSliceReducer from "../Slices/Role/EditRoleSlice";
import DeleteRoleReducer from "../Slices/Role/DeleteRoleSlice";
import ListRoleScreenYGPermissionSliceReducer from "../Slices/RoleScreenYGPermission/ListRoleScreenYGPermissionSlice";
import ManageRoleScreenYGPermissionSliceReducer from "../Slices/RoleScreenYGPermission/ManageRoleScreenYGPermissionSlice";

import ListdaycalculationSliceReducer from "../Slices/day_calculation/ListdaycalculationSlice";

import AddFalgSliceReducer from "../Slices/Falg/AddFalgSlice";
import ListFlagSliceReducer from "../Slices/Falg/ListFlagSlice";

import AddFalgExamSliceReducer from "../Slices/FalgExam/AddFalgExamSlice";
import ListFlagExamSliceReducer from "../Slices/FalgExam/ListFlagExamSlice";
import ListFlagExamSubmissionSliceReducer from "../Slices/FalgExam/ListFlagExamSubmissionSlice";

// added by Manikandan
import AddVideoUploadSlice from "../Slices/VideoUpload/AddVideoUploadSlice";
import DeleteVideoUploadSliceReducer from "../Slices/VideoUpload/DeleteVideoUploadSlice";
import EditVideoUploadSliceReducer from "../Slices/VideoUpload/EditVideoUploadSlice";
import ListVideoUploadSliceReducer from "../Slices/VideoUpload/ListVideoUploadSlice";
import ListTopicSectionVideoSlice from "../Slices/VideoUpload/ListTopicSectionVideoSlice";
import ListVideoSubjectSliceReducer from "../Slices/UserVideoLessons/ListVideosubjectSlice";
import ListVideoTopicSliceReducer from "../Slices/UserVideoLessons/ListVideoTopicSlice";
import ListVideoLessonsListSliceReducer from "../Slices/UserVideoLessons/ListVideoLessonsList";
import AddNoteVideoLessonsSliceReducer from "../Slices/UserVideoLessons/AddNoteVideoLessons";
import ListNoteVideoLessonSliceReducer from "../Slices/UserVideoLessons/ListNoteVideoLessons";
import ListGetVideoLessonsSliceReducer from "../Slices/UserVideoLessons/ListGetVideoLessons";
import EditNoteVideoLessonsSliceReducer from "../Slices/UserVideoLessons/EditNoteVideoLessons";
import DeleteNoteVideoLessonsSliceReducer from "../Slices/UserVideoLessons/DeleteNoteVideoLessons";
import AskAIVideoLessonsSliceReducer from "../Slices/UserVideoLessons/AskAIVideoLessons";
import ListDiscussionVideoLessonsSliceReducer from "../Slices/UserVideoLessons/ListDiscussionVideoLessons";
import AddDiscussionVideoLessonsSliceReducer from "../Slices/UserVideoLessons/AddDiscussionVideoLessons";
import EditDiscussionVideoLessonsSliceReducer from "../Slices/UserVideoLessons/EditDiscussionVideoLessons";
import DeleteDiscussionVideoLessonsSliceReducer from "../Slices/UserVideoLessons/DeleteDiscussionVideoLessons";
import LikeDiscussionVideoLessonsSliceReducer from "../Slices/UserVideoLessons/LikeDiscussionVideoLessons";
import FavAndWatchLaterVideoLessonsSliceReducer from "../Slices/UserVideoLessons/FavAndWatchLaterVideoLessons";
import CourseDetailsVideoLessonsSliceReducer from "../Slices/UserVideoLessons/CourseDetailsVideoLessons";
import ProgressUpdateVideoLessonsSliceReducer from "../Slices/UserVideoLessons/ProgressUpdateVideoLessons";
import DashboardCalenderDataSliceReducer from "../Slices/DashboardData/DashboardCalenderData";
import DashboardweeklyprefSliceReducer from "../Slices/DashboardData/Dashboardweeklypref";
import AchievementsSliceReducer from "../Slices/DashboardData/Achievements";
import Recommended_ActionSliceReducer from "../Slices/DashboardData/Recommended_Actions";
import List_Question_SubTypeSliceReducer from "../Slices/QuestionType/GetQuestionSubType";
import ListSubjectListSliceReducer from "../Slices/QuestionType/ListSubjectListSlice";
import WritingChatbotReducer from "../Slices/Chatbot/WritingChatbotSlicer";
import VideoLessonAnalyticsReducer from "../Slices/UserVideoLessons/VideoLessonAnalytics";

// Booklet
import BookletMaterialCreateReducer from "../Slices/Booklet/Admin/BookletMaterial/BookletMaterialCreate";
import BookletMaterialReadReducer from "../Slices/Booklet/Admin/BookletMaterial/BookletMaterialRead";
import BookletMaterialUpdateReducer from "../Slices/Booklet/Admin/BookletMaterial/BookletMaterialUpdate";
import BookletMaterialDeleteReducer from "../Slices/Booklet/Admin/BookletMaterial/BookletMaterialDelete";
import BookletRequestReadReducer from "../Slices/Booklet/Admin/BookletRequest/BookletRequestRead";
import BookletRequestDecisionReadReducer from "../Slices/Booklet/Admin/BookletRequest/BookletRequestDecisionRead";
import BookletRequestDecisionReducer from "../Slices/Booklet/Admin/BookletRequest/BookletRequestDecision";
import PrinterOptionsSliceReducer from "../Slices/Booklet/Tutor/PrinterOptions/PrinterOptions";
import CentreMasterCreateReducer from "../Slices/Booklet/Admin/CentreMaster/CentreMasterCreate";
import CentreMasterReadReducer from "../Slices/Booklet/Admin/CentreMaster/CentreMatserRead";
import CentreMasterLocationReducer from "../Slices/Booklet/Admin/CentreMaster/CentreMatserLocation";
import CentreMasterUpdateReducer from "../Slices/Booklet/Admin/CentreMaster/CentreMasterUpdate";
import CentreMasterDeleteReducer from "../Slices/Booklet/Admin/CentreMaster/CentreMasterDelete";
import CentreMasterMappingCreateReducer from "../Slices/Booklet/Admin/CentreMasterMapping/CentreMasterMappingCreate";
import CentreMasterMappingReadReducer from "../Slices/Booklet/Admin/CentreMasterMapping/CentreMatserMappingRead";
import CentreMasterMappingUpdateReducer from "../Slices/Booklet/Admin/CentreMasterMapping/CentreMasterMappingUpdate";
import CentreMasterMappingDeleteReducer from "../Slices/Booklet/Admin/CentreMasterMapping/CentreMasterMappingDelete";
import PrinterCreate_UpdateReducer from "../Slices/Booklet/Admin/PrinterMaster/PrinterMasterCreate_Update";
import PrinterMasterReadReducer from "../Slices/Booklet/Admin/PrinterMaster/PrinterMasterRead";
import TutorsReadReducer from "../Slices/Booklet/Admin/Tutors/TutorsRead";
import TutorCreate_UpdateSliceReducer from "../Slices/Booklet/Admin/Tutors/TutorsCreate_Update";
import CommonFilterReducer from "../Slices/Booklet/CommonFilter/CommonFilter";
import StudyMaterialReadReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialRead";
import StudyMaterialPreviewReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialPreview";
import StudyMaterialReadByIdReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialReadById";
import StudyMaterialCartReadReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialCartRead";
import StudyMaterialAddToCartCreateReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialAddToCartCreate";
import StudyMaterialRequestCreateReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialRequestCreate";
import LessonPlanReadReducer from "../Slices/Booklet/Tutor/LessonPlan/LessonPlanRead";
import MyRequestReadReducer from "../Slices/Booklet/Tutor/MyRequest/MyRequestRead";
import RolesReadSliceReducer from "../Slices/Booklet/Admin/Tutors/RoleRead ";
import PolicyMasterReadSliceReducer from "../Slices/PrivacyPolicy/PolicyMasterRead";
import PolicyCreate_UpdateSliceReducer from "../Slices/PrivacyPolicy/policyMasterCreate_Update";
import Privacy_PolicyReadSliceReducer from "../Slices/PrivacyPolicy/PrivacyPolicyRead";
import Terms_and_ConditionReadSliceReducer from "../Slices/PrivacyPolicy/TeramsandConditionRead";
import ChatWithElliotSlicerReducer from "../Slices/ChatwithElliot/ChatwithElliot";
import DefaultPrinterSliceReducer from "../Slices/Booklet/Tutor/PrinterOptions/DefaultPrinter";
import Subject_Drive_MapMasterReadSliceReducer from "../Slices/Booklet/Admin/Subject_drive_map/SubjectDriveMapMasterRead";
import SubjectFolderMasterReadSliceReducer from "../Slices/Booklet/Admin/Subject_drive_map/SubjectFolderRead";
import Subject_Drive_MapCreate_UpdateSliceReducer from "../Slices/Booklet/Admin/Subject_drive_map/SubjectFolderDriveMasterCreate_Update";
import ClassSelectionCreate_UpdateSliceReducer from "../Slices/Booklet/Admin/ClassSelectionMaster/ClassSelectionMasterCreate_Update";
import ClassSelectionMasterReadSliceReducer from "../Slices/Booklet/Admin/ClassSelectionMaster/ClassSelectionMasterRead";
import ClassSelectionSubjectReadSliceReducer from "../Slices/Booklet/Admin/ClassSelectionMaster/ClassSelectionSubjectRead";
import ClassSubjectReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/ClassSubject";
import ClassYeargroupReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/ClassYeargroup";
import ClassDrive_fileReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/ClassDriveFile";
import TutorDashboardStatusReadSliceReducer from "../Slices/Booklet/Tutor/Dashboard/DashboardStatus";
import TutorDashboardSummaryReadSliceReducer from "../Slices/Booklet/Tutor/Dashboard/DashboardSummary";
import TutorDashboardClassesReadSliceReducer from "../Slices/Booklet/Tutor/Dashboard/DashboardAssignedClasses";
import TutorAdminDashboardReadSliceReducer from "../Slices/Booklet/Admin/DashboardData/Dashboarddata";
import ReprintSliceReducer from "../Slices/Booklet/Tutor/Reprint/Reprint";
import AiDriveSearchSliceReducer from "../Slices/Booklet/Tutor/AiSearch/AiSearch";
import PrinterListSliceReducer from "../Slices/Booklet/Tutor/PrinterOptions/Printlist";
import PrinterChangeSliceReducer from "../Slices/Booklet/Tutor/PrinterOptions/PrinterChange";
import DefaultPrinterUpdateSliceReducer from "../Slices/Booklet/Tutor/PrinterOptions/DefaultPrinterChange";
import GateAdminDashboardDataReducer from "../Slices/GateAdminDashboard/Admindashboard";
import TestCompletedFilterReducer from "../Slices/GateAdminDashboard/TestCompeletedFilter";
import OverallActivityFilterReducer from "../Slices/GateAdminDashboard/OverallActivityFilter";
import ActiveUserFilterReducer from "../Slices/GateAdminDashboard/ActiveUserFilter";
import LeadDataSliceReducer from "../Slices/CRM/Leads/LeadViewdata/LeadData";
import Session_CrudSliceReducer from "../Slices/CRM/Leads/Session/Session_crud";
import SessionReadSliceReducer from "../Slices/CRM/Leads/Session/SessionRead";
import PreviousClassReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/Class selection page/PreviousClassRead";
import PreviousClass_CRUDReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/Class selection page/PreviousClass_CRUD";
import ClassSelectionDataReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/Class selection page/ClassSelectionData";
import DashboardPrintlistSliceReducer from "../Slices/Booklet/Tutor/PrinterOptions/DashboardPrintlist";
import TutorDashboardCalendarSliceReducer from "../Slices/Booklet/Tutor/Dashboard/DashbaoardCalender";
import Tutoradmin_CalendarSliceReducer from "../Slices/Booklet/Admin/CalenderView/CalenderView";
import AdminReprintSliceReducer from "../Slices/Booklet/Admin/AdminReprint/AdminReprint";
import ReportListSliceReducer from "../Slices/Booklet/Admin/Report/ReportList";
import ReportFilterSliceReducer from "../Slices/Booklet/Admin/Report/ReportFilter";
import ReportReprintSliceReducer from "../Slices/Booklet/Admin/Report/ReportReprint";
import ClassCenterReadSliceReducer from "../Slices/Booklet/Tutor/ClassSelection/ClassCenter";
import TutorReportListSliceReducer from "../Slices/Booklet/Tutor/Report/TutorReportList";
import TutorReportFilterSliceReducer from "../Slices/Booklet/Tutor/Report/TutorReportFilter";
import StudyMaterialCartCountReducer from "../Slices/Booklet/Tutor/StudyMaterial/StudyMaterialCartCount";
import RoleMappingReducer from "../Slices/RoleMapping/RoleMappingList";
import RolesScreenlistReducer from "../Slices/Screen/RolesScreenList";
import AddRolesScreenReducer from "../Slices/RoleMapping/AddRolesScreens";
import ListVideoTutorialsSliceReducer from "../Slices/VideoTutorials/ListVideoTutorialsSlice";
import AddVideoTutorialSliceReducer from "../Slices/VideoTutorials/AddVideoTutorialSlice";
import EditVideoTutorialSliceReducer from "../Slices/VideoTutorials/EditVideoTutorialSlice";
import DeleteVideoTutorialSliceReducer from "../Slices/VideoTutorials/DeleteVideoTutorialSlice";
import ListVideoTutorialCategorySliceReducer from "../Slices/VideoTutorialCategory/ListVideoTutorialCategorySlice";
import AddVideoTutorialCategorySliceReducer from "../Slices/VideoTutorialCategory/AddVideoTutorialCategorySlice";
import EditVideoTutorialCategorySliceReducer from "../Slices/VideoTutorialCategory/EditVideoTutorialCategorySlice";
import DeleteVideoTutorialCategorySliceReducer from "../Slices/VideoTutorialCategory/DeleteVideoTutorialCategorySlice";
import TopicSelectionSliceReducer from "../Slices/TopicSelection/TopicSelectionSlice";
import ScheduledClassesSliceReducer from "../Slices/ScheduledClasses/ScheduledClassesSlice";
import ScheduleSetupDataSliceReducer from "../Slices/ScheduledClasses/ScheduleSetupDataSlice";
import CreateMeetLinkSliceReducer from "../Slices/ScheduledClasses/CreateMeetLinkSlice";
import CreateScheduledClassSliceReducer from "../Slices/ScheduledClasses/CreateScheduledClassSlice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    Test: TestReducer,
    Theme: ThemeReducer,
    // day  calculation
    ListdaycalculationSlice: ListdaycalculationSliceReducer,
    // Dashboard
    DashboardCard: DashboardCardReducer,
    // DashboardChart
    DashboardChart: DashboardChartReducer,
    // DashboardData
    DashboardDataCard: DashboardDataCardReducer,
    // Permissions
    PermissionsToPage: PermissionsToPageReducer,
    // SessionExpired
    SessionExpired: SessionExpiredReducer,
    // User Permission
    EditUserPermission: EditUserPermissionsReducer,
    UserPermissionRows: UserPermissionRowsReducer,
    // Login
    LoginSlicer: LoginReducer,
    // google
    GoogleLoginSlicer: GoogleLoginReducer,
    // Registration
    RegistrationSlicer: RegistrationSlicerReducer,
    ListRegistrationYeargroupSlice: ListRegistrationYeargroupSliceReducer,
    // Reset Password
    ResetPassword: ResetPasswordReducer,
    ForgotPassword: ForgotPasswordReducer,

    // Menu
    ListMenuSlice: ListMenuSliceReducer,
    AddMenuSlice: AddMenuSlice,
    EditMenuSlice: EditMenuSliceReducer,
    DeleteMenu: DeleteMenuReducer,

    // Screen
    ScreenList: ScreenListReducer,
    RolesScreenList: RolesScreenlistReducer,

    // Role Mapping
    RoleMappingScreens: RoleMappingReducer,
    AddRolesScreen: AddRolesScreenReducer,

    //   Sudty Node
    ListSubjectNoteSlice: ListSubjectNoteSliceReducer,
    ListSubjectNoteTopicSlice: ListSubjectNoteTopicSliceReducer,
    ListSubjectNoteContentSlice: ListSubjectNoteContentSliceReducer,
    ListSubjectNoteSubTopicSlice: ListSubjectNoteSubTopicSliceReducer,
    // QuestionSubType
    ListQuestionSubTypeSlice: ListQuestionSubTypeSliceReducer,
    QuestionSubTypelistSlice: QuestionSubTypelistSliceReducer,
    AddQuestionSubTypeSlice: AddQuestionSubTypeSlice,
    EditQuestionSubTypeSlice: EditQuestionSubTypeSliceReducer,
    DeleteQuestionSubType: DeleteQuestionSubTypeReducer,

    // QuestionType
    ListQuestionTypeSlice: ListQuestionTypeSliceReducer,
    AddQuestionTypeSlice: AddQuestionTypeSlice,
    EditQuestionTypeSlice: EditQuestionTypeSliceReducer,
    DeleteQuestionType: DeleteQuestionTypeReducer,
    ListDashboardPerformenceTrendSlice: ListDashboardPerformenceTrendReducer,
    ScheduleQuestionTypesSlice: ScheduleQuestionTypesSliceReducer,
    // year group
    ListyearGroupSlice: ListyearGroupSliceReducer,
    AddyearGroupSlice: AddyearGroupSlice,
    EdityearGroupSlice: EdityearGroupSliceReducer,
    DeleteyearGroup: DeleteyearGroupReducer,

    // Exam
    ListExamsubmitSlice: ListExamsubmitSliceReducer,
    ListReViewExamIDSlice: ListReViewExamIDSliceReducer,
    ListReExamIDSlice: ListReExamIDSliceReducer,
    ListReExamPracticeIDSlice: ListReExamPracticeIDSliceReducer,
    PendingExamSlice: PendingExamSliceReducer,
    ListExamIDSlice: ListExamIDSliceReducer,
    ListInstructionExamSlice: ListInstructionExamSliceReducer,
    ListEvaluationSlice: ListEvaluationSliceReducer,
    ListEvaluationPracticewritingExamSlice:
      ListEvaluationPracticewritingExamSliceReducer,
    ListExamSlice: ListExamSliceReducer,
    AddExamSlice: AddExamSlice,
    AddCloseSectionSlice: AddCloseSectionSliceReducer,
    EditExamSlice: EditExamSliceReducer,
    DeleteExam: DeleteExamReducer,
    AddOpenSectionSlice: AddOpenSectionSliceReducer,
    ListExamsubmitoverallSlice: ListExamsubmitoverallSliceReducer,

    // Practice test list
    ListPracticeTestSlice: ListPracticeTestSliceReducer,

    // Practice Exam
    ListReViewExamIDPracticeSlice: ListReViewExamIDPracticeSliceReducer,
    ListEvaluationPracticeSlice: ListEvaluationPracticeSliceReducer,
    ListExamsubmitPracticeSlice: ListExamsubmitPracticeSliceReducer,
    ListPracticeExamSlice: ListPracticeExamSliceReducer,
    PendingPracticeExamSlice: PendingPracticeExamSliceReducer,
    AddPracticeExamSlice: AddPracticeExamSlice,
    EditPracticeExamSlice: EditPracticeExamSliceReducer,
    DeletePracticeExam: DeletePracticeExamReducer,
    ListInstructionPracticeExamSlice: ListInstructionPracticeExamSliceReducer,
    ListPracticeExamIDSlice: ListPracticeExamIDSliceReducer,
    // chatbot
    ChatbotPublicSlicer: ChatbotPublicSlicerReducer,
    WritingChatbotPublicSlicer: WritingChatbotPublicReducer,
    ReadChatbotPublicSlicer: ReadChatbotPublicReducer,
    ExamWritingChatbotPublicSlicer: ExamWritingChatbotPublicReducer,
    ExamReadChatbotPublicSlicer: ExamReadChatbotPublicReducer,
    ChatpracticeEvaluationSlicer: ChatpracticeEvaluationSlicerReducer,
    ChatbotExamEvaluationSlicer: ChatbotExamEvaluationSlicerReducer,

    // chat with elliot
    ChatWithElliotSlicer: ChatWithElliotSlicerReducer,
    // chatbot
    ChatbotSlicer: ChatbotSlicerReducer,
    WritingChatbot: WritingChatbotReducer,

    // student exam
    ListStudentExamSlice: ListStudentExamSliceReducer,
    AddStudentExamSlice: AddStudentExamSlice,
    EditStudentExamSlice: EditStudentExamSliceReducer,
    PopupStudentExamSlice: PopupStudentExamSliceReducer,

    // Support
    AddSupportSlice: AddSupportSliceReducer,
    ListFAQSlice: ListFAQSliceReducer,
    // studentPractice exam
    ListStudentExamPracticeSlice: ListStudentExamPracticeSliceReducer,
    AddStudentExamPracticeSlice: AddStudentExamPracticeSlice,
    EditStudentExamPracticeSlice: EditStudentExamPracticeSliceReducer,
    PopupStudentExamPracticeSlice: PopupStudentExamPracticeSliceReducer,

    // subscription
    ListSubscriptionSlice: ListSubscriptionSliceReducer,
    AddSubscriptionSlice: AddSubscriptionSliceReducer,
    DeleteSubscription: DeleteSubscriptionReducer,

    // ExamModel
    ListExamModelSlice: ListExamModelSliceReducer,
    AddExamModelSlice: AddExamModelSlice,
    EditExamModelSlice: EditExamModelSliceReducer,
    DeleteExamModel: DeleteExamModelReducer,

    // ExamHistory
    ListExamHistoryReWritingSlice: ListExamHistoryReWritingSliceReducer,
    ListMockExamHistorySlice: ListMockExamHistorySliceReducer,

    ListExamHistorySlice: ListExamHistorySliceReducer,
    AddExamHistorySlice: AddExamHistorySlice,
    EditExamHistorySlice: EditExamHistorySliceReducer,
    DeleteExamHistory: DeleteExamHistoryReducer,
    // Questions
    ListQuestionsSlice: ListQuestionsSliceReducer,
    QuestionMappingSlice: QuestionMappingSliceReducer,
    AddQuestionsSlice: AddQuestionsSlice,
    EditQuestionsSlice: EditQuestionsSliceReducer,
    DeleteQuestions: DeleteQuestionsReducer,
    BulkUploadQuestionsSlice: BulkUploadQuestionsSliceReducer,

    // Options
    ListOptionsSlice: ListOptionsSliceReducer,
    AddOptionsSlice: AddOptionsSlice,
    EditOptionsSlice: EditOptionsSliceReducer,
    DeleteOptions: DeleteOptionsReducer,
    // Instruction
    ListInstructionSlice: ListInstructionSliceReducer,
    AddInstructionSlice: AddInstructionSlice,
    EditInstructionSlice: EditInstructionSliceReducer,
    DeleteInstruction: DeleteInstructionReducer,
    // ExamAnswer
    ListExamAnswerSlice: ListExamAnswerSliceReducer,
    AddExamAnswerSlice: AddExamAnswerSlice,
    EditExamAnswerSlice: EditExamAnswerSliceReducer,
    DeleteExamAnswer: DeleteExamAnswerReducer,
    // ExamAnswerPractice
    ListExamAnswerPracticeSlice: ListExamAnswerPracticeSliceReducer,
    AddExamAnswerPracticeSlice: AddExamAnswerPracticeSlice,

    // FeedBack
    ListFeedBackSlice: ListFeedBackSliceReducer,
    AddFeedBackSlice: AddFeedBackSlice,
    EditFeedBackSlice: EditFeedBackSliceReducer,
    DeleteFeedBack: DeleteFeedBackReducer,

    // FeedBack
    AddFeedBackPracticeSlice: AddFeedBackPracticeSliceReducer,

    // Package
    ListPackageSlice: ListPackageSliceReducer,
    AddPackageSlice: AddPackageSlice,
    EditPackageSlice: EditPackageSliceReducer,
    DeletePackage: DeletePackageReducer,
    ListPackageDomainSlice: ListPackageDomainSliceReducer,
    ListDomainSlice: ListDomainSliceReducer,
    ListSubscribedUserSlice: ListSubscribedUserSliceReducer,
    ListPackagePeriodSlice: ListPackagePeriodSliceReducer,

    // Courses
    ListCoursesSlice: ListCoursesSliceReducer,
    AddCoursesSlice: AddCoursesSlice,
    EditCoursesSlice: EditCoursesSliceReducer,
    DeleteCourses: DeleteCoursesReducer,

    // UserAdmin
    ListUserAdminSlice: ListUserAdminSliceReducer,
    AddUserAdminSlice: AddUserAdminSliceReducer,
    EditUserAdminSlice: EditUserAdminSliceReducer,
    DeleteUserAdmin: DeleteUserAdminReducer,

    // Setting
    ListSettingResetSlice: ListSettingResetSliceReducer,
    ListSettingResetMockSlice: ListSettingResetMockSliceReducer,
    AddSettingSlice: AddSettingSliceReducer,

    // User
    ListUserSlice: ListUserSliceReducer,
    AddUserSlice: AddUserSlice,
    EditUserSlice: EditUserSliceReducer,
    DeleteUser: DeleteUserReducer,
    //  list user
    ListRegionSlice: ListRegionSliceReducer,
    ListYearGroupSlice: ListYearGroupSliceReducer,

    //user package
    ListUserPackageSlice: ListUserPackageSliceReducer,
    ListUserPackageDetailsSlice: ListUserPackageDetailsSliceReducer,
    ListUserExamListSlice: ListUserExamListSliceReducer,
    PendingExamList: PendingExamListReducer,
    // mock exam
    MockExamSlice: MockExamSliceReducer,

    // Reading Prompt
    ReadingPromptSlice: ReadingPromptSliceReducer,

    ListWritingExamAISlice: ListWritingExamAISliceReducer,

    // writing exam
    ListWritingExamAIPracticeSlice: ListWritingExamAIPracticeSliceReducer,
    ListWritingExamPracticeSlice: ListWritingExamPracticeSliceReducer,

    // Skill
    AddArithmeticGameSkillSlice: AddArithmeticGameSkillSlice,
    AddMemoryGameSkillSlice: AddMemoryGameSkillSlice,

    // exter api
    ListCountryListSlice: ListCountryListSliceReducer,
    ListStateSlice: ListStateSliceReducer,
    //  Flag
    AddFalgSlice: AddFalgSliceReducer,
    ListFlagSlice: ListFlagSliceReducer,

    //  Flag list
    AddFalgExamSlice: AddFalgExamSliceReducer,
    ListFlagExamSlice: ListFlagExamSliceReducer,
    ListFlagExamSubmissionSlice: ListFlagExamSubmissionSliceReducer,

    // Examdate
    ListExamdateSlice: ListExamdateSliceReducer,
    AddExamdateSlice: AddExamdateSlice,
    EditExamdateSlice: EditExamdateSliceReducer,
    DeleteExamdate: DeleteExamdateReducer,

    // Role
    ListRoleSlice: ListRoleSliceReducer,
    AddRoleSlice: AddRoleSlice,
    EditRoleSlice: EditRoleSliceReducer,
    DeleteRole: DeleteRoleReducer,
    ListRoleScreenYGPermissionSlice: ListRoleScreenYGPermissionSliceReducer,
    ManageRoleScreenYGPermissionSlice: ManageRoleScreenYGPermissionSliceReducer,

    // Yearlevel_map
    ListYearlevel_mapSlice: ListYearlevel_mapSliceReducer,
    AddYearlevel_mapSlice: AddYearlevel_mapSlice,
    EditYearlevel_mapSlice: EditYearlevel_mapSliceReducer,
    DeleteYearlevel_map: DeleteYearlevel_mapReducer,

    // Country
    ListCountrySlice: ListCountrySliceReducer,
    AddCountrySlice: AddCountrySlice,
    EditCountrySlice: EditCountrySliceReducer,
    DeleteCountry: DeleteCountryReducer,

    // Terms and policy
    ListPolicyMaster: PolicyMasterReadSliceReducer,
    Add_update_policyMaster: PolicyCreate_UpdateSliceReducer,
    listPrivacyPolicy: Privacy_PolicyReadSliceReducer,
    listTermsandCondition: Terms_and_ConditionReadSliceReducer,

    // New Dashbord
    ListDailygoalsSlice: ListDailygoalsSliceReducer,
    ListDashboardprogressSlice: ListDashboardprogressSliceReducer,
    ListPerformanceSlice: ListPerformanceSliceReducer,
    ListPrefmanceTrendSlice: ListPrefmanceTrendSliceReducer,
    ListQuestionBankSlice: ListQuestionBankSliceReducer,
    ListRecentActivitySlice: ListRecentActivitySliceReducer,
    AddCreategoalsSlice: AddCreategoalsSliceSlice,

    // ContentMobile
    ListContentMobileSlice: ListContentMobileSliceReducer,
    AddContentMobileSlice: AddContentMobileSlice,
    EditContentMobileSlice: EditContentMobileSliceReducer,
    DeleteContentMobile: DeleteContentMobileReducer,

    //SubtopicMobile
    ListSubtopicMobileSlice: ListSubtopicMobileSliceReducer,
    AddSubtopicMobileSlice: AddSubtopicMobileSlice,
    EditSubtopicMobileSlice: EditSubtopicMobileSliceReducer,
    DeleteSubtopicMobile: DeleteSubtopicMobileReducer,

    // SubjectMobile
    ListSubjectMobileSlice: ListSubjectMobileSliceReducer,
    AddSubjectMobileSlice: AddSubjectMobileSlice,
    EditSubjectMobileSlice: EditSubjectMobileSliceReducer,
    DeleteSubjectMobile: DeleteSubjectMobileReducer,

    // SubscribedMap
    ListSubscribedMapSlice: ListSubscribedMapSliceReducer,
    AddSubscribedMapSlice: AddSubscribedMapSlice,
    EditSubscribedMapSlice: EditSubscribedMapSliceReducer,
    DeleteSubscribedMap: DeleteSubscribedMapReducer,

    // billing
    ListBillingSlice: ListBillingSliceReducer,
    // UserProfile
    ListUserProfileSlice: ListUserProfileSliceReducer,
    AddUserProfileSlice: AddUserProfileSlice,
    EditUserProfileSlice: EditUserProfileSliceReducer,
    DeleteUserProfile: DeleteUserProfileReducer,

    // SideMenu Permission
    SideMenuPermission: SideMenuPermissionReducer,

    // Video Upload(admin) -- added by Manikandan
    AddVideoUploadSlice: AddVideoUploadSlice,
    DeleteVideoUploadSliceReducer: DeleteVideoUploadSliceReducer,
    EditVideoUploadSliceReducer: EditVideoUploadSliceReducer,
    ListVideoUploadSliceReducer: ListVideoUploadSliceReducer,
    ListTopicSectionVideoSlice: ListTopicSectionVideoSlice,

    // Video Lesson (User) -- added by Manikandan
    ListVideoSubjectSliceReducer: ListVideoSubjectSliceReducer,
    ListVideoTopicSliceReducer: ListVideoTopicSliceReducer,
    ListVideoLessonsListSlices: ListVideoLessonsListSliceReducer,
    AddNoteVideoLessonsSliceReducer: AddNoteVideoLessonsSliceReducer,
    ListNoteVideoLessonSliceReducer: ListNoteVideoLessonSliceReducer,
    ListGetVideoLessonsSliceReducer: ListGetVideoLessonsSliceReducer,
    EditNoteVideoLessonsSliceReducer: EditNoteVideoLessonsSliceReducer,
    DeleteNoteVideoLessonsSliceReducer: DeleteNoteVideoLessonsSliceReducer,
    AskAIVideoLessonsSliceReducer: AskAIVideoLessonsSliceReducer,
    ListDiscussionVideoLessonsSliceReducer:
      ListDiscussionVideoLessonsSliceReducer,
    AddDiscussionVideoLessonsSliceReducer:
      AddDiscussionVideoLessonsSliceReducer,
    EditDiscussionVideoLessonsSliceReducer:
      EditDiscussionVideoLessonsSliceReducer,
    DeleteDiscussionVideoLessonsSliceReducer:
      DeleteDiscussionVideoLessonsSliceReducer,
    LikeDiscussionVideoLessonsSliceReducer:
      LikeDiscussionVideoLessonsSliceReducer,
    FavAndWatchLaterVideoLessonsSliceReducer:
      FavAndWatchLaterVideoLessonsSliceReducer,
    CourseDetailsVideoLessonsSliceReducer:
      CourseDetailsVideoLessonsSliceReducer,
    ProgressUpdateVideoLessonsSliceReducer:
      ProgressUpdateVideoLessonsSliceReducer,
    DashboardCalenderDataSliceReducer: DashboardCalenderDataSliceReducer,
    DashboardweeklyprefSliceReducer: DashboardweeklyprefSliceReducer,
    AchievementsSlicer: AchievementsSliceReducer,
    Recommended_ActionSlicer: Recommended_ActionSliceReducer,
    VideoLessonAnalyticsSlice: VideoLessonAnalyticsReducer,
    List_Question_SubTypeSliceReducer: List_Question_SubTypeSliceReducer,
    ListSubjectListSliceReducer: ListSubjectListSliceReducer,

    TopicSelectionSlice: TopicSelectionSliceReducer,
    ScheduledClassesSlice: ScheduledClassesSliceReducer,
    ScheduleSetupDataSlice: ScheduleSetupDataSliceReducer,
    CreateMeetLinkSlice: CreateMeetLinkSliceReducer,
    CreateScheduledClassSlice: CreateScheduledClassSliceReducer,

    //-----------------------------------------------------------------
    // Booklet

    //------------------------------------------------------------
    // Common Filter
    CommonFilterSlice: CommonFilterReducer,

    //------------------------------------------------------------

    // Admin Module

    //Booklet Material
    BookletMaterialCreateSlice: BookletMaterialCreateReducer,
    BookletMaterialReadSlice: BookletMaterialReadReducer,
    BookletMaterialUpdateSlice: BookletMaterialUpdateReducer,
    BookletMaterialDeleteSlice: BookletMaterialDeleteReducer,

    //Booklet Request
    BookletRequestReadSlice: BookletRequestReadReducer,
    BookletRequestDecisionReadSlice: BookletRequestDecisionReadReducer,
    BookletRequestDecisionSlice: BookletRequestDecisionReducer,

    //Booklet Request Printer options
    PrinterOptionsSlice: PrinterOptionsSliceReducer,
    DashbnoardPrintList: DashboardPrintlistSliceReducer,
    DefaultPrinterOptions: DefaultPrinterSliceReducer,
    DefaultPrinterOptionsUpdate: DefaultPrinterUpdateSliceReducer,
    PrinterListSlice: PrinterListSliceReducer,
    PrinterChangeSlice: PrinterChangeSliceReducer,

    // Centre Master
    CentreMasterCreateSlice: CentreMasterCreateReducer,
    CentreMasterReadSlice: CentreMasterReadReducer,
    CentreMasterUpdateSlice: CentreMasterUpdateReducer,
    CentreMasterDeleteSlice: CentreMasterDeleteReducer,
    CentreMasterLocationSlice: CentreMasterLocationReducer,

    // Centre Master Mapping
    CentreMasterMappingCreateSlice: CentreMasterMappingCreateReducer,
    CentreMasterMappingReadSlice: CentreMasterMappingReadReducer,
    CentreMasterMappingUpdateSlice: CentreMasterMappingUpdateReducer,
    CentreMasterMappingDeleteSlice: CentreMasterMappingDeleteReducer,

    // Printer Master
    PrinterCreate_UpdateSlice: PrinterCreate_UpdateReducer,
    PrinterMasterReadSlice: PrinterMasterReadReducer,

    // Tutors
    RolesReadSlice: RolesReadSliceReducer,
    TutorsReadSlice: TutorsReadReducer,
    TutorsCreate_UpdateSlice: TutorCreate_UpdateSliceReducer,

    //----------------------------------------------------------------

    // Tutor Module

    //Class Selection & Study Material
    StudyMaterialReadSlice: StudyMaterialReadReducer,
    StudyMaterialPreviewSlice: StudyMaterialPreviewReducer,
    StudyMaterialReadByIdSlice: StudyMaterialReadByIdReducer,
    StudyMaterialCartReadSlice: StudyMaterialCartReadReducer,
    StudyMaterialCartCountSlice: StudyMaterialCartCountReducer,
    StudyMaterialAddToCartCreateSlice: StudyMaterialAddToCartCreateReducer,
    StudyMaterialRequestCreateSlice: StudyMaterialRequestCreateReducer,

    // Lesson Plan
    LessonPlanReadSlice: LessonPlanReadReducer,

    // MyRequest
    MyRequestReadSlice: MyRequestReadReducer,

    //Subject_Drive_mapping
    Subject_Drive_MapMasterRead: Subject_Drive_MapMasterReadSliceReducer,
    Subject_Drive_MapCreate_Update: Subject_Drive_MapCreate_UpdateSliceReducer,
    SubjectFolderMasterRead: SubjectFolderMasterReadSliceReducer,

    // Class Selection Master
    ClassSelectionCreate_Update: ClassSelectionCreate_UpdateSliceReducer,
    ClassSelectionMasterRead: ClassSelectionMasterReadSliceReducer,
    ClassSelectionSubjectRead: ClassSelectionSubjectReadSliceReducer,

    //booklet dashborad class selection
    ClassSubjectRead: ClassSubjectReadSliceReducer,
    ClassCenterRead: ClassCenterReadSliceReducer,
    ClassYeargroupRead: ClassYeargroupReadSliceReducer,
    ClassDrive_fileRead: ClassDrive_fileReadSliceReducer,

    PreviousClass_Read: PreviousClassReadSliceReducer,
    PreviousClass_CRUD: PreviousClass_CRUDReadSliceReducer,
    ClassSelectionData: ClassSelectionDataReadSliceReducer,

    //booklet Tutor dashboard

    TutorDashboardStatusRead: TutorDashboardStatusReadSliceReducer,
    TutorDashboardSummaryRead: TutorDashboardSummaryReadSliceReducer,
    TutorDashboardClassesRead: TutorDashboardClassesReadSliceReducer,
    TutorDashboardCalendar: TutorDashboardCalendarSliceReducer,

    //TutorAdmin dashboard
    TutorAdminDashboarRead: TutorAdminDashboardReadSliceReducer,
    TutorAdminDashboardCalender: Tutoradmin_CalendarSliceReducer,
    TutorAdminReprint: AdminReprintSliceReducer,

    // Tutor Admin Report
    TutorAdminReportList: ReportListSliceReducer,
    TutorAdminReportFilter: ReportFilterSliceReducer,
    TutorAdminReportReprint: ReportReprintSliceReducer,

    // tutot Report
    TutorReportList: TutorReportListSliceReducer,
    TutorReportFilter: TutorReportFilterSliceReducer,

    //Tutor reprint
    ReprintSlice: ReprintSliceReducer,

    //Tutor ai drive serach
    AiDriveSearch: AiDriveSearchSliceReducer,

    //Gate Admin Dashboard
    GateAdminDashboardData: GateAdminDashboardDataReducer,
    TestCompletedFilter: TestCompletedFilterReducer,
    OverallActivityFilter: OverallActivityFilterReducer,
    ActiveUserFilter: ActiveUserFilterReducer,

    //#region CRM_module
    LeadDataSlice: LeadDataSliceReducer,

    SessionReadSlice: SessionReadSliceReducer,
    SessionCrudSlice: Session_CrudSliceReducer,
    //#endregion CRM_module

    ListVideoTutorialsSlice: ListVideoTutorialsSliceReducer,
    AddVideoTutorialSlice: AddVideoTutorialSliceReducer,
    EditVideoTutorialSlice: EditVideoTutorialSliceReducer,
    DeleteVideoTutorialSlice: DeleteVideoTutorialSliceReducer,
    ListVideoTutorialCategorySlice: ListVideoTutorialCategorySliceReducer,
    AddVideoTutorialCategorySlice: AddVideoTutorialCategorySliceReducer,
    EditVideoTutorialCategorySlice: EditVideoTutorialCategorySliceReducer,
    DeleteVideoTutorialCategorySlice: DeleteVideoTutorialCategorySliceReducer,

    //--------------------------------------------------------------------
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSage);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
